import React from 'react'

import { ShareDialogItemTypes } from '@src/components/ShareDialog/ShareDialog'
import { Field } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { composeValidators, useValidators } from '@utils/validators'
import {
  Typography,
  Divider,
  Button,
  CircularProgress,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import { useCurrentUser } from '@utils/useCurrentUser'
import clsx from 'clsx'
import { ResponsiveModalActions } from '@src/components/ResponsiveModal/ResponsiveModal'

interface ShareDialogEmailFieldsProps {
  itemType: ShareDialogItemTypes
  loading: boolean
}

const useStyles = makeStyles((theme) => ({
  alertBox: { marginBottom: theme.spacing(6) },
  subLabel: {
    margin: theme.spacing(1, 0),
    display: 'block',
  },
  isHidden: { display: 'none' },
  fromField: { marginTop: theme.spacing(4) },
  divider: {
    margin: theme.spacing(6, 0),
    backgroundColor: theme.palette.grey[400],
  },
}))

const ShareDialogEmailFields: React.FC<ShareDialogEmailFieldsProps> = ({
  itemType,
  loading,
}) => {
  const { formatMessage } = useIntl()
  const { required, ccEmail, email } = useValidators()
  const classes = useStyles()
  const { currentUser } = useCurrentUser()

  return (
    <>
      <Divider className={classes.divider} />
      <Field
        name="toEmailsRaw"
        component={LiquidInputAdapter}
        multiline
        rows={2}
        validate={composeValidators(required, ccEmail)}
        label={
          <>
            <Typography variant="h3" component="span">
              <FormattedMessage
                id="SHARE_LINK_IN_EMAIL"
                defaultMessage="Share Link in Email"
              />
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.subLabel}
            >
              <FormattedMessage
                id="RECIPIENT_EMAIL_ADDRESS"
                defaultMessage="Recipient Email Address *(Separate multiple email addresses with commas)"
              />
            </Typography>
          </>
        }
      />

      <Field
        name="emailFrom"
        component={LiquidInputAdapter}
        className={currentUser?.email && classes.isHidden}
        validate={composeValidators(required, email)}
        label={
          <Typography
            variant="body2"
            component="div"
            className={clsx(
              classes.fromField,
              currentUser?.email && classes.isHidden
            )}
          >
            <FormattedMessage id="FROM" defaultMessage="From" />
          </Typography>
        }
        placeholder={formatMessage({
          id: 'EXAMPLE_YOUR_EMAIL',
          defaultMessage: 'youremail@email.com',
        })}
        data-testid={`pdp-${itemType}-product-email-from`}
      />

      <ResponsiveModalActions>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          disabled={loading}
          startIcon={
            loading && (
              <CircularProgress color="inherit" size={20} thickness={5} />
            )
          }
        >
          <FormattedMessage id="SEND_EMAIL" defaultMessage="Send Email" />
        </Button>
      </ResponsiveModalActions>
    </>
  )
}
export default ShareDialogEmailFields
